export default {
  "welcome": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Witaj!"])}
  },
  "website_link": {
    "tooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Przejdź do Universal Profiles"])}
  },
  "transactions": {
    "value": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Transfer wartości"])}
    },
    "transfer_to": {
      "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wyślij do:"])}
    }
  },
  "transaction": {
    "set_data": {
      "permission_change": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zmiana uprawnień"])}
    },
    "no_data": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Brak danych dotyczących wykonania"])},
    "generic": {
      "unavailable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["niedostępny"])},
      "method": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Metoda:"])},
      "function": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wykonanie Smart Kontraktu"])},
      "event": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zdarzenie:"])},
      "deploy_contract": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wdrożenie kontraktu"])}
    },
    "details": {
      "error": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Błąd"])},
      "estimated": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["(szacowany)"])},
      "value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wartość"])},
      "gas_used_tooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rzeczywista ilość gazu zużyta przez transakcję."])},
      "total_gas_fee": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Całkowita opłata za gaz"])},
      "nonce": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nonce"])},
      "value_tooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wartość wysłana w tokenie natywnym."])},
      "gas_used": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zużyty gaz"])},
      "copy_transaction_id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Skopiuj identyfikator transakcji"])},
      "block_number": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Blok"])},
      "transactionIndex": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pozycja"])},
      "error_tooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Komunikat o błędzie w przypadku nieudanej transakcji."])},
      "view_explorer": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zobacz transakcję w eksploratorze "])},
      "priority_fee": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Opłata priorytetowa (GWEI)"])},
      "gas_price": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cena gazu"])},
      "gas_limit_tooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Maksymalna ilość gazu zatwierdzona do transakcji."])},
      "block_number_tooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Numer bloku zawierający transakcję."])},
      "hash": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hash transakcji"])},
      "max_fee_per_gas": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Maksymalna opłata za gaz"])},
      "status_tooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bieżący stan transakcji: UKOŃCZONA, NIEPOWODZONA (błąd), OCZEKUJĄCA (W trakcie), SZKIC (przed potwierdzeniem)"])},
      "hash_tooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["TxHash lub Hash transakcji to unikalny 66-znakowy identyfikator, który jest generowany za każdym razem, gdy transakcja jest wykonywana."])},
      "to": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Do"])},
      "nonce_tooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Numer transakcji z adresu nadawczego. Każda transakcja wysłana z adresu zwiększa wartość jednorazową o 1."])},
      "transaction_fee_tooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Całkowita opłata transakcyjna."])},
      "execute_direct": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["klucz kontrollera"])},
      "spend_limit_amount": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kwota limitu wydatków"])},
      "activity_log": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dziennik aktywności"])},
      "network_tooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Id sieci"])},
      "transaction_fee": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Opłata transakcyjna"])},
      "to_tooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Odbiorca transakcji. Może być kolejny UP lub EoA."])},
      "network": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sieć"])},
      "gas_price_tooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cena za jednostkę gazu określona przez nadawcę. Wyższe ceny gazu mogą nadać priorytet uwzględnianiu transakcji w okresach wysokiego zużycia."])},
      "executeMethod": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wykonane przez"])},
      "status": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Status"])},
      "base_fee": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Opłata podstawowa (GWEI)"])},
      "gas_limit": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Limit gazu"])},
      "transaction_hash": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Transaction Hash"])},
      "timestamp_tooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Data i godzina transakcji."])},
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Szczegóły"])},
      "timestamp": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Data"])},
      "cumulative_gas_used": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Całkowity zużyty gas"])}
    }
  },
  "sign": {
    "tag": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wiadomość"])},
    "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Podpisanie tej wiadomości może mieć niebezpieczne skutki uboczne. Podpisuj wiadomości tylko ze stron, którym chcesz udostępnić swoje konto."])},
    "confirm": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Podpisz"])},
    "cancel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Anuluj"])}
  },
  "settings": {
    "security": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prywatność"])},
      "export_pk": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eksportuj klucz prywatny"])}
    },
    "network": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sieć"])},
      "add_network_tooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dodaj sieć niestandardową"])}
    },
    "language": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Język"])},
      "option": {
        "pl-PL": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Polski"])},
        "en-US": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Angielski"])},
        "de-DE": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Niemiecki"])}
      }
    },
    "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ustawienia"])},
    "currency": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zmiana waluty"])},
      "option": {
        "usd": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["USD - Dolar amerykański"])},
        "pln": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["PLN - złoty polski"])},
        "gbp": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["GBP - Funt szterling"])},
        "eur": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["EUR - Euro"])}
      }
    }
  },
  "select_account": {
    "empty_state": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nie masz jeszcze utworzonych profili. Otwórz rozszerzenie Universal Profile w przeglądarce i utwórz je."])},
    "button": {
      "cancel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Anuluj"])}
    }
  },
  "qr_code": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mój kod QR"])}
  },
  "profile": {
    "update": {
      "success": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Twój profil został zaktualizowany!"])},
      "error": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nie mogliśmy zaktualizować Twojego profilu"])}
    },
    "tooltip": {
      "expand": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rozwiń"])},
      "edit": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edytuj"])}
    },
    "save": {
      "updating": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktualizujemy Twój profil..."])},
      "creating": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tworzymy Twój profil..."])}
    },
    "empty": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wygląda pusto tutaj!"])}
    },
    "create": {
      "success": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Twój profil został utworzony!"])},
      "error": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nie mogliśmy utworzyć Twojego profilu"])},
      "authorized_apps": {
        "browser_extension_display_name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["To rozszerzenie przeglądarki"])}
      }
    }
  },
  "permissions": {
    "update": {
      "success": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uprawnienia aplikacji zostały zaktualizowane."])},
      "loading": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktualizujemy uprawnienia aplikacji..."])},
      "error": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nie mogliśmy zaktualizować uprawnień aplikacji."])}
    }
  },
  "not_found": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Błąd 404:"])},
    "subtitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Strona nie znaleziona!"])}
  },
  "network": {
    "edit": {
      "submit": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zapisz"])},
      "heading": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edutuj sieć niestandardową"])}
    },
    "delete": {
      "trigger": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Usuń"])}
    },
    "add": {
      "websocket_url_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["RPC Websocket URL"])},
      "warning": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dodawaj tylko sieci niestandardowe, którym ufasz!"])},
      "submit": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dodaj sieć"])},
      "rpc_url_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["RPC URL"])},
      "name_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nazwa"])},
      "heading": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dodaj sieć niestandardową"])},
      "explorer_url_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Explorer URL (opcjonalny)"])},
      "close": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Anuluj"])}
    }
  },
  "modal": {
    "network_delete": {
      "text": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Ta akcja usunie <b>", _interpolate(_named("networkName")), "</b> z twoich sieci niestandardowych."])},
      "heading": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Usuń sieć niestandardową"])},
      "delete": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Usuń"])},
      "cancel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Anuluj"])}
    },
    "invalid_permissions": {
      "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nie mogliśmy wczytać uprawnień dla tej aplikacji."])},
      "heading": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Błąd!"])},
      "confirm": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Powrót"])}
    },
    "disconnect_app": {
      "heading": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Odłącz aplikację"])},
      "cancel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Anuluj"])}
    }
  },
  "input": {
    "validators": {
      "ws": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Musi być prawidłowym adresem URL dla Websocketa"])},
      "url": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Musi być prawidłowym adresem URL"])},
      "required": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pole jest wymagane"])},
      "password_special": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hasło musi zawierać znak specjalny"])},
      "password_numeric": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hasło musi zawierać cyfrę"])},
      "password_length": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hasło musi zawierać minimum 8 znaków"])},
      "password_alpha": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hasło musi zawierać literę"])},
      "localhost": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dozwolona tylko ścieżka localhost"])},
      "invalid_length": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Wartość powinna zawierać ", _interpolate(_named("length")), " znaki"])},
      "invalid_character": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nazwa użytkownika zawiera nieprawidłowy znak"])},
      "exists": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wartość już istnieje"])},
      "email": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Musi być prawidłowym adresem e-mail."])}
    }
  },
  "full_screen": {
    "reduce": {
      "tooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zmniejsz"])}
    },
    "edit": {
      "tooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edytuj"])}
    },
    "bio": {
      "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Opis bio"])},
      "empty_state": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nie ma tu jeszcze nic do zobaczenia!"])}
    }
  },
  "create_profile": {
    "web_link": {
      "error": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["URL nie powinien być pusty"])}
    },
    "user_name": {
      "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wpisz nazwę użytkownika"])},
      "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nazwa użytkownika"])},
      "hint": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Używaj liter, cyfr i myślników"])}
    },
    "title": {
      "edit_profile": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edytuj profil"])}
    },
    "tags": {
      "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dodaj etykietę"])},
      "help": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dodaj tagi (maksymalnie 3), aby ludzie wiedzieli, kim jesteś."])}
    },
    "references": {
      "title_placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wprowadź tytuł łącza"])},
      "link_placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["https://website.com"])},
      "link_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Referencje internetowe"])},
      "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DODAJ ODNIESIENIE"])}
    },
    "profile": {
      "add_photo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dodaj zdjęcie profilowe"])}
    },
    "cover": {
      "change": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zmienić okładkę"])},
      "add": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dodaj okładkę"])}
    },
    "button": {
      "save": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ZAPISZ"])},
      "cancel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ANULUJ"])}
    },
    "bio": {
      "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Napisz kim jesteś"])},
      "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Opis bio"])}
    }
  },
  "confirmation": {
    "your_balance": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Twój balans"])},
    "title": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["<b style=\"font-weight: 600\">", _interpolate(_named("origin")), "</b> prosi o transakcję"])},
    "sender_balance": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Moje saldo: ", _interpolate(_named("senderBalance"))])},
    "quota_usage": {
      "progress_info": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Twoja suma ", _interpolate(_named("total")), " ", _interpolate(_named("unit")), " zostanie zresetowana w dniu ", _interpolate(_named("date"))])},
      "progress_error": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Przekroczyłeś limit. Następny reset ", _interpolate(_named("date"))])},
      "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wykorzystanie limitu"])}
    },
    "lyx_token": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["LYX Token"])},
    "key_usage": {
      "transaction_fee_to_balance_separator": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([" z "])},
      "progress_label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("estimatedGas")), " z ", _interpolate(_named("balance"))])},
      "progress_info": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Użycie nie jest odliczane od salda profilowego"])},
      "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Użycie klucza"])}
    },
    "hide": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Schowaj"])},
    "header": {
      "tx_speed": {
        "medium": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Średnia"])},
        "low": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Niska"])},
        "high": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wysoka"])},
        "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Szybkość tranzakcji"])}
      }
    },
    "confirm": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Długie kliknięcie, aby potwierdzić"])},
    "cancel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Anuluj"])},
    "advanced_view": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["WIDOK ZAAWANSOWANY"])}
  },
  "clipboard_copy": {
    "hover_text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kopiuj do schowka"])},
    "copy_text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Skopiowano!"])}
  },
  "backend": {
    "unlock": {
      "incorrect_password": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Niepoprawne hasło"])}
    }
  },
  "authenticate": {
    "unlock": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Odblokuj"])},
    "password": {
      "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hasło"])}
    }
  },
  "app_detail": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uprawnienia"])},
    "set_data": {
      "error": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uprawnienie SUPER_SETDATA jest włączone, więc biała lista zostanie pominięta. Kliknij aby wyłączyć te uprawnienie."])}
    },
    "permissions": {
      "transfervalue": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Transfer"])},
      "standards": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Standarty"])},
      "smart_contracts": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Smart contracts"])},
      "sign": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Podpisać się"])},
      "setdata": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ustawić dane"])},
      "keymanager": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Menedżer kluczy"])},
      "functions": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Funkcje"])},
      "execute": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wykonanie"])},
      "editpermissions": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zmień uprawnienia"])},
      "deploy": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wdrożenie"])},
      "changeowner": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zmień menadżera kluczy"])},
      "changekeys": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zmiana kluczy"])},
      "call": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wykonaj"])},
      "addpermissions": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uprawnienie dodania adresu"])}
    },
    "execute_data": {
      "error": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uprawnienie SUPER_CALL lub SUPER_STATICCALL jest włączone i umieszczanie na białej liście zostanie pominięte. Kliknij aby wyłączyć te uprawnienia."])}
    },
    "allowed_execution": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dozwolone wywołanie"])}
  },
  "app": {
    "camera_enabled": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["włączony"])},
    "camera_disabled": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["wyłączony"])}
  },
  "address_validator": {
    "invalid_hex": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["To nie jest prawidłowa wartość szesnastkowa"])},
    "invalid_address": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Niepoprawny adres"])},
    "address_exists": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Adres już istnieje"])}
  },
  "address_form": {
    "submit": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dodaj"])},
    "standards": {
      "add_placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dodaj adres Standardu do białej listy..."])}
    },
    "set-data-keys": {
      "add_placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dodaj klucz Set Data do białej listy..."])}
    },
    "functions": {
      "add_placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dodaj adres Funkcji do białej listy..."])}
    },
    "addresses": {
      "add_placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dodaj adres Smart contract do białej listy..."])}
    }
  },
  "add_new_account": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dodaj nowy profil"])},
    "button": {
      "create": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Stwórz profil"])},
      "cancel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Anuluj"])}
    }
  },
  "activity": {
    "transaction": {
      "to": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Do:"])},
      "show": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pokaż"])},
      "cancel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Anuluj"])}
    },
    "status": {
      "pending": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Oczekujący"])},
      "failed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Błąd"])},
      "draft": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Szkic"])},
      "completed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zakończony"])}
    },
    "event": {
      "sign": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Podpis"])},
      "Generic": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Transakcja"])},
      "Executed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Transakcja"])},
      "DataChanged": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zmiana danych"])},
      "ContractCreated": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Konto utworzone"])}
    }
  }
}